import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { PdfExportService } from '../services/pdf-export/pdf-export.service';

@Directive({
  selector: '[pdfExportHost]',
  standalone: false
})
export class PdfExportHostDirective implements OnInit, OnDestroy {
  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private pdfExportService: PdfExportService
  ) {}

  ngOnInit(): void {
    this.pdfExportService.registerHost(this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.pdfExportService.unregisterHost(this.elementRef.nativeElement);
  }
}
